import {
  GET_BENEFITS_GAMEFICATION_POINT,
  GET_BENEFITS_GAMEFICATION_POINT_SUCCESS,
  GET_BENEFITS_GAMEFICATION_POINT_ERROR,
  GET_BENEFITS_GAMEFICATION_POINT_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitsGamificationPoint = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFITS_GAMEFICATION_POINT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFITS_GAMEFICATION_POINT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_BENEFITS_GAMEFICATION_POINT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BENEFITS_GAMEFICATION_POINT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitsGamificationPoint;
